import React from 'react';

const Section = ({ 
  children,
  backgroundColor = 'transparent',
  paddingY = 'lg',
  maxWidth = 'wide',
  className = '' 
}) => {
  const paddingClasses = {
    none: 'py-0',
    sm: 'py-8',
    md: 'py-12',
    lg: 'py-16 md:py-24',
    xl: 'py-24 md:py-32',
  };

  const maxWidthClasses = {
    narrow: 'max-w-3xl',
    default: 'max-w-5xl',
    wide: 'max-w-7xl',
    full: 'max-w-full',
  };

  return (
    <section 
      className={`${paddingClasses[paddingY]} ${className}`}
      style={{ backgroundColor }}
    >
      <div className={`${maxWidthClasses[maxWidth]} mx-auto px-4 md:px-6`}>
        {children}
      </div>
    </section>
  );
};

Section.builderConfig = {
  isContainer: true,
  props: {
    backgroundColor: {
      type: 'color',
      label: 'Background Color',
      default: 'transparent',
    },
    paddingY: {
      type: 'select',
      label: 'Vertical Padding',
      default: 'lg',
      options: [
        { value: 'none', label: 'None' },
        { value: 'sm', label: 'Small' },
        { value: 'md', label: 'Medium' },
        { value: 'lg', label: 'Large' },
        { value: 'xl', label: 'Extra Large' },
      ],
    },
    maxWidth: {
      type: 'select',
      label: 'Max Width',
      default: 'wide',
      options: [
        { value: 'narrow', label: 'Narrow' },
        { value: 'default', label: 'Default' },
        { value: 'wide', label: 'Wide' },
        { value: 'full', label: 'Full Width' },
      ],
    },
  },
};

export default Section;
